import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLeftSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM6.58594 12L11 16.4141L12.4141 15L10.4141 13H17V11H10.4141L12.4141 9L11 7.58594L6.58594 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftSquare;
